import { Plus } from '@phosphor-icons/react';
import { cloneElement, ReactElement, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color } from 'theme/enums';

import { UpsertPricingProfileAdminUser } from './UpsertPricingProfileAdminUser';

interface IProps {
  pricingProfileId: number;
  buttonElement?: ReactElement;
  buttonLabel?: string;
  onSubmitSuccess: () => void;
  disabled?: boolean;
}

export const UpsertPricingProfileAdminUserButton = ({
  pricingProfileId,
  buttonElement,
  buttonLabel,
  onSubmitSuccess,
  disabled = false,
}: IProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const button = useMemo(() => {
    if (buttonElement) {
      return cloneElement(buttonElement, {
        onClick: disabled ? undefined : () => setIsOpen(true),
      });
    }

    return (
      <Button
        text={buttonLabel ?? t('buttonLabelAddAdminUser')}
        color={Color.SUCCESS}
        startDecorator={<Plus />}
        onClick={() => setIsOpen(true)}
        disabled={disabled}
      />
    );
  }, [buttonElement, buttonLabel, disabled, t]);

  return (
    <>
      {button}

      <UpsertPricingProfileAdminUser
        pricingProfileId={pricingProfileId}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmitSuccess={onSubmitSuccess}
      />
    </>
  );
};
